<template>
  <div class="container-fluid mobile_div  first_page"  >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
<!--    <nav aria-label="breadcrumb"    v-if="is_load==true" >-->
<!--      <ol class="breadcrumb">-->
<!--        <li class="breadcrumb-item"><router-link tag="a" to="/" >Главная</router-link></li>-->

<!--         <li class="breadcrumb-item active" aria-current="page"  > {{ page.title }}</li>-->
<!--      </ol>-->
<!--    </nav>-->
    <div class="row block_landing block_landing_type_one " v-if="is_load==true">

      <div class="col-12 inside_landing d-flex justify-content-center">
        <div class="row  content_block container mt-2 mb-2">
          <div class="col-12 "  v-if="page.content.blocks">

              <h2 class="ml-3 text-center">  {{ page.title }} </h2>


            <editorjsrender  class="ml-3" v-if="is_load && page.content.blocks " :blocks_json="page.content.blocks"></editorjsrender>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/models/Api";
import Editorjsrender from "@/models/Editorjsrender";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "Page",
  data: function () {
    return {
      page:[],

      is_load:false,

    }
  },
  mounted() {
    var app=this;
    let alias = app.$route.params.alias;

    Api.Pages_GetOnlyPage(alias,function(data){
      var page=data.page;

      app.page=page;

      app.is_load=true;

    },function(data){
      app.$router.push({name:'404'});
    });
  },
  components: {
    'editorjsrender': Editorjsrender,
    LoadingBlock,
  }
}
</script>

<style scoped>

</style>